import { Action, getModule, Module, VuexModule } from 'vuex-module-decorators';
import store from '@/store/index';
import { WS_URL as ApiUrl } from '@/config';
import axios from 'axios';
import { NotificationService } from '@/services/notification-service';

export interface ActivationLogEntry {
  id: string;
  eventType: number;
  event: string;
  message: string;
  remarks: string;
  originAccountId?: number;
  originAccount?: string;
  originSessionId?: string;
  createTime: string;
}

export interface ErrorLogEntry {
  id: string;
  controller: string;
  type: string;
  message: string;
  trace: string;
  data: string;
  originAccountId: number;
  originAccount?: string;
  originSessionId: string;
  createTime: string;
}

export interface MailLogEntry {
  mailLogId: number;
  email: string;
  fullName: string;
  subject: string;
  sent: string;
  notes: string;
}

@Module({ dynamic: true, namespaced: true, store, name: 'reports' })
export class ReportsModule extends VuexModule {
  @Action
  async getActivationLog(): Promise<ActivationLogEntry[]> {
    try {
      const response = await axios.get<ActivationLogEntry[]>(`${ApiUrl}/api/reports/activationlog`);
      return response.data;
    } catch (error) {
      NotificationService.NotifyError('Could not load the activation log.');
      return [];
    }
  }

  @Action
  async getErrorsLog(): Promise<ErrorLogEntry[]> {
    try {
      const response = await axios.get<ErrorLogEntry[]>(`${ApiUrl}/api/reports/errorslog`);
      return response.data;
    } catch (error) {
      NotificationService.NotifyError('Could not load the errors log.');
      return [];
    }
  }

  @Action
  async getMailLog(): Promise<MailLogEntry[]> {
    try {
      const response = await axios.get<MailLogEntry[]>(`${ApiUrl}/api/reports/maillog`);
      return response.data;
    } catch (error) {
      NotificationService.NotifyError('Could not load the mail log.');
      return [];
    }
  }

  @Action
  async deleteMailLogs(ids: number[]): Promise<number> {
    try {
      const response = await axios.delete<{ deleted: number }>(`${ApiUrl}/api/reports/maillog`, {
        data: ids
      });

      const deleted = response.data.deleted;
      NotificationService.NotifySuccess(`${deleted} mail log ${deleted === 1 ? 'entry' : 'entries'} deleted.`);
      return deleted;
    } catch (error) {
      NotificationService.NotifyError('Could not delete the selected mail log entries.');
      return 0;
    }
  }
}

export const ReportsStore = getModule(ReportsModule);
